<template>
    <v-combobox
        v-model="selectedLocale"
        :label="$t('language')"
        :items="items"
        item-title="libelle"
        item-value="value"
        :return-object="false"
        @update:model-value="changeLanguage"
        variant="outlined" 
        density="compact"
    />
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import store from '../store'
const emit = defineEmits(['selectedLocale'])
const { locale } = useI18n()
const selectedLocale = ref('fr')
const items = ref([
    { value: 'fr', libelle: 'Français' },
    { value: 'nl', libelle: 'Nederlands' }
])
const SUPPORTED_LOCALES = ['fr', 'nl']

function changeLanguage(newLang) {
    // newLang est directement la valeur string grâce à :return-object="false"
    if (!newLang || !SUPPORTED_LOCALES.includes(newLang)) return
    locale.value = newLang
    selectedLocale.value = newLang
    localStorage.setItem('userLanguage', newLang)
    // store.state.user.language=newLang
    // console.log({...store.state.user});
    store.commit('addUser',{...store.state.user,language:newLang})
    emit('selectedLocale', newLang)
    // console.log({...store.state.user});
    
}

onMounted(() => {
    let initialLang = store.state.user?.language || localStorage.getItem('userLanguage')
    if (!initialLang || !SUPPORTED_LOCALES.includes(initialLang)) initialLang = 'fr'
    locale.value = initialLang
    selectedLocale.value = initialLang
})
</script>